var _rect, _path, _rect2, _path2, _path3, _path4, _g, _path5, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 25,
    viewBox: "0 0 168 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 24,
    rx: 3,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.607 8.955c-1.572.327-2.538 1.201-2.618 2.369-.067 1.03.398 1.614 1.903 2.369.874.44 1.143.672 1.143 1.006 0 .828-1.522 1.077-3.082.506-.306-.113-.575-.186-.593-.16-.043.047-.318 1.678-.288 1.708.067.06.905.268 1.328.327.648.095 2.109.048 2.605-.083 1.284-.34 2.116-1.15 2.3-2.239.177-1.071-.337-1.773-1.848-2.529-.905-.458-1.217-.708-1.217-.988 0-.25.325-.56.678-.65.44-.118 1.468-.047 1.982.137.144.052.276.095.36.117.061.016.104-.015.118-.077.055-.247.179-.939.238-1.32.026-.17-.053-.293-.22-.34l-.22-.064c-.594-.167-1.975-.214-2.569-.09Zm-16.757.1c0 .047.281.166.72.303.393.124.906.322 1.14.446l.038.02a1 1 0 0 1 .499.617l.862 3.079.774 2.769a1 1 0 0 0 .963.73h.928a1 1 0 0 0 .918-.603l1.44-3.337c.935-2.173 1.718-3.976 1.73-4.018.025-.06-.22-.078-1.126-.078h-.468a1 1 0 0 0-.93.633l-.822 2.082a110.95 110.95 0 0 1-1.03 2.57c-.047.109-.109.113-.14-.002a5.875 5.875 0 0 1-.084-.36 6.444 6.444 0 0 0-.162-.669c-.013-.046-.032-.09-.05-.136a.704.704 0 0 1-.008-.025c-.026-.08-.014-.163-.026-.245-.09-.615-.7-3.327-.787-3.455-.233-.345-.317-.363-2.434-.38-1.585-.019-1.945-.007-1.945.059Zm10.317 3.81c-.226 1.34-.458 2.68-.697 4.018a.111.111 0 0 0 .109.136h1.211a1 1 0 0 0 .986-.832l.513-3.025c.367-2.118.673-3.922.691-4.018a.131.131 0 0 0-.128-.16h-1.18a1 1 0 0 0-.987.832l-.518 3.048Zm13.064-3.821a.986.986 0 0 0-.594.374c-.092.137-3.4 7.56-3.4 7.626 0 .025.514.03 1.138.025l.51-.008a.927.927 0 0 0 .853-.605.913.913 0 0 1 .857-.597h1.61c.367 0 .686.254.769.613a.794.794 0 0 0 .771.607H31a.112.112 0 0 0 .11-.136c-.068-.262-1.756-7.888-1.756-7.924 0-.053-1.89-.03-2.122.025Zm.898 3.565c.166.762.306 1.436.306 1.5 0 .108-.054.114-.917.114h-.514a.275.275 0 0 1-.257-.375c.777-2.013 1.035-2.662 1.052-2.643.013.012.159.643.33 1.404Z",
    fill: "#2A2C6A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 0.5,
    width: 36,
    height: 24,
    rx: 3,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.81 19.306c3.876 0 7.019-3.09 7.019-6.903 0-3.812-3.143-6.903-7.02-6.903a7.06 7.06 0 0 0-4.552 1.65 7.06 7.06 0 0 0-4.553-1.65c-3.876 0-7.018 3.09-7.018 6.903 0 3.812 3.142 6.903 7.018 6.903a7.06 7.06 0 0 0 4.553-1.65 7.06 7.06 0 0 0 4.553 1.65Z",
    fill: "#ED0006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.257 17.657a6.842 6.842 0 0 0 2.466-5.254 6.842 6.842 0 0 0-2.466-5.254A7.06 7.06 0 0 1 66.81 5.5c3.876 0 7.019 3.09 7.019 6.903 0 3.812-3.143 6.903-7.02 6.903a7.06 7.06 0 0 1-4.552-1.65Z",
    fill: "#F9A000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.257 17.657a6.842 6.842 0 0 0 2.466-5.254 6.842 6.842 0 0 0-2.466-5.254 6.842 6.842 0 0 0-2.466 5.254c0 2.104.957 3.988 2.466 5.254Z",
    fill: "#FF5E00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 0.5,
    width: 36,
    height: 24,
    rx: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M89.872 8.595h31.457v7.81H89.872z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.024,
    y: 9.729,
    width: 5.184,
    height: 5.871,
    rx: 2.592,
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2.501v23.994s20.44.003 32.995.003V.502H89.2Zm13.626 9.647c.392 0 .731.104 1.13.31v1.07c-.379-.375-.72-.524-1.154-.524-.853 0-1.53.712-1.53 1.617 0 .954.661 1.617 1.577 1.617.412 0 .743-.156 1.107-.523v1.094a2.523 2.523 0 0 1-1.154.261c-1.385 0-2.471-1.064-2.471-2.45a2.48 2.48 0 0 1 2.495-2.472Zm-4.308.024c.511 0 .974.177 1.365.523l-.47.642c-.238-.269-.457-.38-.73-.38-.393 0-.683.226-.683.522 0 .255.16.391.706.595 1.035.383 1.343.726 1.342 1.474 0 .912-.655 1.546-1.6 1.546-.693 0-1.205-.282-1.625-.904l.589-.57c.21.409.554.618.988.618.406 0 .707-.284.707-.666 0-.456-.4-.548-.895-.737-.85-.323-1.153-.659-1.153-1.308 0-.771.633-1.355 1.46-1.355Zm8.145 0a2.431 2.431 0 0 1 2.425 2.449c0 1.357-1.081 2.473-2.425 2.473-1.344 0-2.448-1.116-2.448-2.473a2.45 2.45 0 0 1 2.448-2.45Zm-15.348.095h1.342c1.475 0 2.495.962 2.495 2.354 0 .733-.466 2.354-2.495 2.354h-1.342v-4.708Zm4.26 0h.919v4.708h-.918v-4.708Zm13.348 0h.988l1.248 3.162 1.271-3.162h.989l-2.025 4.827h-.494l-1.977-4.827Zm4.896 0h2.59v.785h-1.672v1.046h1.601v.808h-1.601v1.26h1.672v.809h-2.59v-4.708Zm3.178 0h1.365c1.05 0 1.648.497 1.648 1.379 0 .721-.374 1.214-1.059 1.355l1.459 1.974h-1.13l-1.247-1.902h-.118v1.902h-.918v-4.708Zm.918.737v1.427h.259c.581 0 .895-.263.895-.737 0-.46-.305-.69-.871-.69h-.283Zm-25.682.048v3.114h.235c1.639 0 1.742-1.19 1.742-1.545 0-.741-.431-1.57-1.671-1.57h-.306Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 0,
    width: 36,
    height: 25
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#016FD0",
    d: "M132 .5h36v24h-36z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 0.5,
    width: 36,
    height: 24,
    rx: 3,
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.002 18.86v-5.506h5.997l.644.816.664-.816h21.767v5.127s-.57.374-1.228.38h-12.052l-.726-.868v.868h-2.377v-1.482s-.325.207-1.027.207h-.809v1.275h-3.599l-.642-.833-.652.833h-5.96ZM132 9.204l1.352-3.065h2.339l.767 1.717V6.14h2.907l.457 1.241.443-1.24h13.05v.623s.686-.624 1.814-.624l4.234.015.754 1.694V6.14h2.433l.669.974v-.974h2.456v5.507h-2.456l-.641-.977v.977h-3.575l-.359-.868h-.961l-.354.868h-2.424c-.97 0-1.59-.612-1.59-.612v.612h-3.655l-.725-.868v.868h-13.591l-.359-.868h-.958l-.356.868H132V9.204Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.83 6.818-1.824 4.123h1.187l.337-.826h1.956l.335.826h1.214l-1.822-4.123h-1.383Zm.675.96.596 1.442h-1.194l.598-1.442ZM137.161 10.94V6.817l1.687.006.981 2.658.958-2.664h1.674v4.123h-1.06V7.902l-1.124 3.038h-.929l-1.127-3.038v3.038h-1.06ZM143.188 10.94V6.817h3.459v.922h-2.388v.705h2.332v.868h-2.332v.733h2.388v.895h-3.459ZM147.26 6.818v4.123h1.06V9.476h.447l1.271 1.465h1.295l-1.394-1.519c.572-.047 1.163-.525 1.163-1.266 0-.868-.701-1.338-1.483-1.338h-2.359Zm1.06.922h1.212c.291 0 .502.221.502.434 0 .274-.274.434-.486.434h-1.228V7.74ZM152.618 10.94h-1.082V6.817h1.082v4.123ZM155.185 10.94h-.234c-1.13 0-1.817-.866-1.817-2.045 0-1.207.679-2.078 2.107-2.078h1.171v.977h-1.214c-.58 0-.99.44-.99 1.112 0 .798.469 1.133 1.144 1.133h.279l-.446.901ZM157.493 6.818l-1.824 4.123h1.187l.337-.826h1.956l.335.826h1.213l-1.822-4.123h-1.382Zm.674.96.597 1.442h-1.195l.598-1.442ZM160.82 10.94V6.817h1.348l1.721 2.59v-2.59h1.06v4.123h-1.304l-1.765-2.658v2.658h-1.06ZM139.728 18.155v-4.122h3.46v.922h-2.389v.705h2.333v.868h-2.333v.732h2.389v.895h-3.46ZM156.679 18.155v-4.122h3.46v.922h-2.388v.705h2.321v.868h-2.321v.732h2.388v.895h-3.46ZM143.322 18.155l1.685-2.036-1.725-2.086h1.336l1.027 1.29 1.03-1.29h1.284l-1.702 2.061 1.688 2.061h-1.336l-.997-1.27-.973 1.27h-1.317ZM148.069 14.033v4.123h1.088v-1.302h1.116c.945 0 1.66-.487 1.66-1.434 0-.785-.561-1.387-1.522-1.387h-2.342Zm1.088.933h1.176c.305 0 .523.181.523.474 0 .275-.217.475-.527.475h-1.172v-.95ZM152.394 14.033v4.123h1.061V16.69h.446l1.271 1.465h1.296l-1.395-1.52c.572-.046 1.163-.524 1.163-1.266 0-.867-.701-1.337-1.482-1.337h-2.36Zm1.061.922h1.211c.291 0 .503.22.503.434 0 .274-.274.434-.487.434h-1.227v-.868ZM160.631 18.155v-.895h2.121c.314 0 .45-.165.45-.345 0-.174-.135-.349-.45-.349h-.958c-.834 0-1.298-.494-1.298-1.235 0-.66.425-1.298 1.663-1.298h2.065l-.446.927h-1.786c-.341 0-.446.174-.446.34 0 .172.13.36.39.36h1.005c.929 0 1.332.512 1.332 1.183 0 .722-.449 1.313-1.383 1.313h-2.259ZM164.521 18.155v-.895h2.122c.314 0 .45-.165.45-.345 0-.174-.136-.349-.45-.349h-.959c-.834 0-1.298-.494-1.298-1.235 0-.66.425-1.298 1.664-1.298h2.022l-.404.927h-1.786c-.341 0-.446.174-.446.34 0 .172.13.36.391.36h1.004c.929 0 1.332.512 1.332 1.183 0 .722-.449 1.313-1.383 1.313h-2.259Z",
    fill: "#016FD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 0.5,
    width: 36,
    height: 24,
    rx: 1,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.2,
    y: 0.5,
    width: 35,
    height: 24,
    rx: 1,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 104.93,
    y1: 10.542,
    x2: 107.651,
    y2: 14.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88271B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C23022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#E2491E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59314"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPayments);
export default __webpack_public_path__ + "static/media/footer-payments.ff4a0f92c15c405059a5eec0ac4cf779.svg";
export { ForwardRef as ReactComponent };